import { useEffect, useRef } from 'react';
import type { JawsScanResponse } from '@/schema/jawsScan';
import { SegmentationScene } from './three/SegmentationScene';
import useSegmentationStore from './hooks/useSegmentationStore';
import useTeethSelectionStore from './hooks/useTeethSelectionStore';

interface Props {
  jawsScan: JawsScanResponse;
}

export function SegmentationCanvas({ jawsScan }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const sceneRef = useRef<SegmentationScene>(undefined);
  const { reset } = useSegmentationStore();
  const { reset: resetTeethSelection } = useTeethSelectionStore();

  useEffect(() => {
    if (!containerRef.current) return;

    const scene = new SegmentationScene(containerRef.current, jawsScan);
    sceneRef.current = scene;
    scene.init();

    // cleanup on unmount or jawsScan change
    return () => {
      scene.dispose();
      reset();
      resetTeethSelection();
      sceneRef.current = undefined;
    };
  }, []);

  return <div ref={containerRef} className={'w-full h-full'} />;
}
